import { Typography } from '@mui/material'
import React, { ComponentPropsWithRef } from 'react'

const formatter = (s: string, className = '') =>
    s.split('\n').map((s, i) => (
        <p key={i} className={className}>
            {s}
        </p>
    ))
// @ts-ignore TS2307
interface Props extends ComponentPropsWithRef<typeof Typography> {
    children?: string // FIXME children could be string[] => map()
    outerClassName?: string
    textClassName?: string
}
export const MTypo = (p: Props) => {
    let {
        outerClassName = p.className,
        textClassName = p.className,
        ...rest
    } = p
    return (
        <>
            {typeof p.children === 'string' && (
                <Typography className={outerClassName} {...rest}>
                    {formatter(p.children, textClassName)}
                </Typography>
            )}
            {typeof p.children !== 'string' && (
                <Typography
                    className={`${outerClassName} ${textClassName}`}
                    {...rest}
                >
                    {p.children}
                </Typography>
            )}
        </>
    )
}
